import { cn } from '~/utils'

type Props = {
  isEnabled: boolean
  enabledLabel: string
  disabledLabel: string
  className?: string
}

export const StatusLabel = ({ isEnabled, enabledLabel, disabledLabel, className }: Props) => {
  return (
    <div className={cn('flex items-center gap-1', className)}>
      <div className={cn('h-2 w-2 rounded-full', isEnabled ? 'bg-teal-8' : 'bg-gray-8')}></div>
      <span className="font-medium">{isEnabled ? enabledLabel : disabledLabel}</span>
    </div>
  )
}
